import React, { Component } from 'react'
import { connect } from 'react-redux'

import stateSelector from 'reduxModules/emailConfirmation/selectors'
import dispatchers from 'reduxModules/emailConfirmation/dispatchers'

import withRouterV6 from '../../utils/withRouterV6'
import './styles.css'

export class EmailVerify extends Component {
  componentDidMount() {
    this.props.verifyEmail({ key: this.props.location.query.key })
  }

  render() {
    return <div id="EmailVerify" />
  }
}

export default withRouterV6(connect(stateSelector, dispatchers)(EmailVerify))
